import { ENV } from "../../../base/constants/env";


export const HOW_CREATE_SHIPPING_TEMPLATE = "https://help.etsy.com/hc/en-us/articles/115014115187-Set-Shipping-Costs-with-Shipping-Profiles?segment=selling";
export const BASE_URL_FOR_BASIC_CATEGORIES = ENV.BASIC_CATEGORIES_URL;
